import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import ScheduleCalendar from "../../../components/ScheduleCalendar";

const FieldActivityCalendarList = (props) => {
  const { addForm, update } = props;
  const frmRef = useRef({});
  const [viewData, setViewData] = useState([]);
  const [data, setData] = useState([]);
  const [dataLoad, setDataLoad] = useState("-1");
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  //pagination code

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const offset = currentPage * itemsPerPage;
  const displayedItems = viewData.slice(offset, offset + itemsPerPage);

  const handleItemsChange = (e) => {
    const value = parseInt(e.target.value);
    if (value > 0) {
      setItemsPerPage(value);
    } else {
      setItemsPerPage(10);
    }
  };

  const {
  
    sendRequest: getfieldActivityWeb,
  } = useHttp();

  const fillFieldActivityWeb = (empId) => {
    var temdata = "-1";
    setDataLoad([...temdata]);

    //selectedFromDate,selectedToDate

    // var fdate=moment(selectedFromDate).format("DD/MM/YYYY");
    // var tdate=moment(selectedToDate).format("DD/MM/YYYY");
    // var urlfilter = "";

    //  urlfilter = urlfilter +`&fromDate=${fdate}`;
    //   urlfilter = urlfilter+`&toDate=${tdate}`;

    getfieldActivityWeb(
      {
        url: `/api/fieldActivityWeb/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("temdata", temdata);
        //console.log("data", data);
        setViewData([...data]);
        setData(data);
        var temdata = "1";
        setDataLoad([...temdata]);
        //console.log("temdata", temdata);
      }
    );
  };

  useEffect(() => {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);

    fillFieldActivityWeb(employeeId);
  }, [getfieldActivityWeb]);

  const {
 
    sendRequest: getEmp,
  } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/employeeByUsecase/?useCase=CommercialFarming&&orgId=${localStorage.getItem(
          "orgId"
        )}${urlfilter} `,
      },
      (data) => {
        // //console.log("emp",data.output )
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  function getScheduleDesign() {
    if (viewData.length > 0) {
      // if((dataLoad??"-1  ")!="-1")
      return <ScheduleCalendar scheduledata={viewData} />;
    }
  }

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3"> &nbsp; &nbsp; Field Activity Calendar Detail </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3 text-right"></div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4"> </div>
                    </div>
                    <div className="row">{getScheduleDesign()}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FieldActivityCalendarList;
